import {
    askApi,
    depUrl,
    downgradeUrl,
    upgradeUrl,
    getInvoiceUrl,
    currentBillingCycle,
    getAddonsUrl,
} from '../endpoints';

/**
 * Updating current billing info
 * @param {Object} payload
 * @returns response data
 */
export function updateBilling(payload) {
    return new Promise((resolve) => {
        askApi.patch(depUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

/**
 * Up/Down- grade current user plan
 * @returns response data
 */
export function upgradeUserPlan(isFreePlan) {
    const endpoint = isFreePlan ? upgradeUrl : downgradeUrl;

    return new Promise((resolve) => {
        askApi.post(endpoint).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function getInvoices(id) {
    const query = {
        responseType: 'blob',
        headers: {
            Accept: 'application/pdf',
        },
        params: {
            id: id,
        },
    };

    return new Promise((resolve) => {
        askApi.get(getInvoiceUrl, query).then((response) => {
            if (response.status === 200) {
                const blob = new Blob([response.data], {
                    type: 'application/pdf',
                });

                resolve(blob);
            }
        });
    });
}

export function getCurrentBillingCycle(id) {
    return new Promise((resolve) => {
        askApi.get(`${currentBillingCycle}/${id}`).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function getAddons() {
    return new Promise((resolve) => {
        askApi.get(getAddonsUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
